export const UNIT_DETAILS_OPTION = {
  STATUS: "Status",
  ENERGYUSAGE: "Energy Usage",
  HISTORY: "History",
  OPERATION: "Operation",
  SETTINGS: "Settings",
  LOGS: "Logs",
  DEBUG: "Debug (Full)",
  DEBUGBASIC: "Debug",
  MODEMUSAGE: "Modem Usage",
  UPGRADES_AND_VERSION: "Upgrades and Version",
};

export const UNIT_DETAILS_OPTIONS_TABS = [
  {
    value: UNIT_DETAILS_OPTION.STATUS,
    label: UNIT_DETAILS_OPTION.STATUS,
    accessKey: "status",
  },
  {
    value: UNIT_DETAILS_OPTION.ENERGYUSAGE,
    label: UNIT_DETAILS_OPTION.ENERGYUSAGE,
    accessKey: "energy_usage",
  },
  {
    value: UNIT_DETAILS_OPTION.HISTORY,
    label: UNIT_DETAILS_OPTION.HISTORY,
    accessKey: "history",
  },
  {
    value: UNIT_DETAILS_OPTION.OPERATION,
    label: UNIT_DETAILS_OPTION.OPERATION,
    accessKey: "operation",
  },
  {
    value: UNIT_DETAILS_OPTION.SETTINGS,
    label: UNIT_DETAILS_OPTION.SETTINGS,
    accessKey: "setting",
  },
  {
    value: UNIT_DETAILS_OPTION.LOGS,
    label: UNIT_DETAILS_OPTION.LOGS,
    accessKey: "logs",
  },
  {
    value: UNIT_DETAILS_OPTION.DEBUG,
    label: UNIT_DETAILS_OPTION.DEBUG,
    accessKey: "debug",
  },
  {
    value: UNIT_DETAILS_OPTION.DEBUGBASIC,
    label: "Debug",
    accessKey: "debug_basic",
  },
  {
    value: UNIT_DETAILS_OPTION.MODEMUSAGE,
    label: UNIT_DETAILS_OPTION.MODEMUSAGE,
    accessKey: "debug",
  },
  {
    value: UNIT_DETAILS_OPTION.UPGRADES_AND_VERSION,
    label: UNIT_DETAILS_OPTION.UPGRADES_AND_VERSION,
    accessKey: "debug",
  },
];

export const CONTROL_MODE_STATUS_OPTIONS = [
  { value: "optimisation_setup", label: "Optimisation Setup Required" },
  { value: "optimisation_learning", label: "Optimisation Learning" },
  { value: "optimisation_active", label: "Optimisation Active" },
  { value: "optimisation_amber", label: "Optimisation Amber" },
  { value: "optimisation_tou", label: "Optimisation ToU" },
  { value: "vpp", label: "External Control" },
  { value: "default", label: "Self Powered" },
];

export const MODEM_USAGE_OPTIONS = [
  { value: "optimisation_setup", label: "Optimisation Setup Required" },
  { value: "optimisation_learning", label: "Optimisation Learning" },
  { value: "optimisation_active", label: "Optimisation Active" },
  { value: "optimisation_amber", label: "Optimisation Amber" },
  { value: "optimisation_tou", label: "Optimisation ToU" },
  { value: "vpp", label: "External Control" },
  { value: "default", label: "Self Powered" },
];

export const DAYS_RANGE_FILTERS = [
  { value: "1", label: "1 Day" },
  { value: "3", label: "Last 3 Days" },
  { value: "7", label: "Last 7 Days" },
  { value: "30", label: "Last 30 Days" },
];

export const FROM_TO_DAYS_RANGE_FILTERS = [
  { value: "6h", label: "Last 6 hrs" },
  { value: "12h", label: "Last 12 hrs" },
  { value: "today", label: "Today" },
  { value: "2d", label: "Last 2 days" },
  { value: "7d", label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
];

export const SITE_VIEW = {
  LIST: "List View",
  MAP: "Map View",
};

export const SITE_VIEW_OPTIONS = [
  { label: SITE_VIEW.LIST, value: SITE_VIEW.LIST },
  { label: SITE_VIEW.MAP, value: SITE_VIEW.MAP },
];

export const OPERATION_OPTIONS = {
  MODE: [
    { value: "battery", label: "Battery" },
    { value: "consumption_limit", label: "Consumption Limit" },
    { value: "ev1_charger", label: "EV1 Charger" },
    { value: "export_limit", label: "Export Limit" },
    { value: "generation_limit", label: "Generation Limit" },
    { value: "hotwater", label: "Hot Water" },
    { value: "import_limit", label: "Import Limit" },
    { value: "pv_curtail", label: "PV Curtail" },
    { value: "pvext_curtail", label: "PV External Curtail" },
  ],
  SYSTEM: [
    { value: "interactive", label: "Grid Interactive" },
    { value: "debug", label: "Debug" },
    { value: "off", label: "Off" },
  ],
  BATTERY: [
    { value: "off", label: "Off" },
    { value: "charge", label: "Charge" },
    { value: "discharge", label: "Discharge" },
    { value: "min_export", label: "Minimise Export" },
    { value: "min_import", label: "Minimise Import" },
    { value: "min_usage", label: "Minimise Usage" },
    { value: "storm", label: "Storm" },
  ],
  HOTWATER: [
    { value: "on", label: "On" },
    { value: "off", label: "Off" },
    { value: "boost", label: "Boost" },
  ],
  TARGETTYPE: [
    { value: "target", label: "Target (Hard target)" },
    { value: "aim", label: "Aim (Soft target)" },
  ],
  LIMIT: [
    { value: 0, label: "0 kW" },
    { value: 500, label: "0.5 kW" },
    { value: 1000, label: "1.0 kW" },
    { value: 1500, label: "1.5 kW" },
    { value: 2000, label: "2.0 kW" },
    { value: 2500, label: "2.5 kW" },
    { value: 3000, label: "3.0 kW" },
    { value: 3500, label: "3.5 kW" },
    { value: 4000, label: "4.0 kW" },
    { value: 4500, label: "4.5 kW" },
    { value: 5000, label: "5.0 kW" },
    { value: 6000, label: "6.0 kW" },
    { value: 7000, label: "7.0 kW" },
    { value: 8000, label: "8.0 kW" },
    { value: 9000, label: "9.0 kW" },
    { value: 10000, label: "10.0 kW" },
  ],
  TARGET: [
    { value: -10000, label: "-10.0 kW" },
    { value: -9000, label: "-9.0 kW" },
    { value: -8000, label: "-8.0 kW" },
    { value: -7000, label: "-7.0 kW" },
    { value: -6000, label: "-6.0 kW" },
    { value: -5000, label: "-5.0 kW" },
    { value: -4500, label: "-4.5 kW" },
    { value: -4000, label: "-4.0 kW" },
    { value: -3500, label: "-3.5 kW" },
    { value: -3000, label: "-3.0 kW" },
    { value: -2500, label: "-2.5 kW" },
    { value: -2000, label: "-2.0 kW" },
    { value: -1500, label: "-1.5 kW" },
    { value: -1000, label: "-1.0 kW" },
    { value: -500, label: "-0.5 kW" },
    { value: 0, label: "0 kW" },
    { value: 500, label: "0.5 kW" },
    { value: 1000, label: "1.0 kW" },
    { value: 1500, label: "1.5 kW" },
    { value: 2000, label: "2.0 kW" },
    { value: 2500, label: "2.5 kW" },
    { value: 3000, label: "3.0 kW" },
    { value: 3500, label: "3.5 kW" },
    { value: 4000, label: "4.0 kW" },
    { value: 4500, label: "4.5 kW" },
    { value: 5000, label: "5.0 kW" },
    { value: 6000, label: "6.0 kW" },
    { value: 7000, label: "7.0 kW" },
    { value: 8000, label: "8.0 kW" },
    { value: 9000, label: "9.0 kW" },
    { value: 10000, label: "10.0 kW" },
  ],
  RESERVE: [
    { value: "0", label: "Disabled" },
    { value: "5", label: "5%" },
    { value: "25", label: "25%" },
    { value: "50", label: "50%" },
    { value: "100", label: "100%" },
  ],
  EVMODES: [
    { value: "off", label: "Off" },
    { value: "boost", label: "Boost" },
    { value: "charge", label: "Charge" },
    { value: "sun_soaker", label: "Sun Soaker" },
  ],
  PRIORITY: [
    { value: 10, label: 10 },
    { value: 11, label: 11 },
    { value: 12, label: 12 },
    { value: 13, label: 13 },
    { value: 14, label: 14 },
    { value: 15, label: 15 },
    { value: 16, label: 16 },
    { value: 17, label: 17 },
    { value: 18, label: 18 },
    { value: 19, label: 19 },
  ],
  START_RADIO: [
    { value: "now", label: "Now" },
    { value: "specific", label: "Specific Date and Time" },
  ],
  END_RADIO: [
    { value: "never", label: "Never" },
    { value: "specific", label: "Specific Date and Time" },
  ],
  ON_OFF: [
    { value: true, label: "On" },
    { value: false, label: "Off" },
  ],
};

export const UNIT_LIST_FITLERS = {
  organisation: "",
  group: "",
  installer: "",
  lifecycle: "",
  control_mode_status: "",
  channel: "",
  search: "",
  online: true,
  paginationModel: {
    pageSize: 10,
    page: 0,
  },
};

export const SEASON_START_LIST = [
  { label: "1st January", value: 1 },
  { label: "1st February", value: 2 },
  { label: "1st March", value: 3 },
  { label: "1st April", value: 4 },
  { label: "1st May", value: 5 },
  { label: "1st June", value: 6 },
  { label: "1st July", value: 7 },
  { label: "1st August", value: 8 },
  { label: "1st September", value: 9 },
  { label: "1st October", value: 10 },
  { label: "1st November", value: 11 },
  { label: "1st December", value: 12 },
];

export const CONFIGURE_SEASON_BY_RATES = [
  { label: "Same rates every day", value: true },
  { label: "Different rates for weekdays vs weekends", value: false },
];

export const CONFIGURE_SEASON_HOLIDAYS = [
  { label: "Treat as weekends", value: true },
  { label: "As they fail", value: false },
];

export const getTouStartTime = () => {
  const list = [];
  for (let d = 0; d <= 23; d++) {
    list.push({
      value: d,
      label: `${d}:00`,
    });
    list.push({
      value: d + 0.5,
      label: `${d}:30`,
    });
  }

  return list;
};

export const getBatteryLabel = (value) => {
  const item = OPERATION_OPTIONS.BATTERY.find((it) => it.value === value);
  return item?.label || value;
};

export const ENERGYUSAGE_OPTION = {
  SUMMARY: "Summary",
  HISTORY: "History",
};

export const ENERGYUSAGE_OPTIONS_LIST = [
  {
    value: ENERGYUSAGE_OPTION.SUMMARY,
    label: ENERGYUSAGE_OPTION.SUMMARY,
  },
  {
    value: ENERGYUSAGE_OPTION.HISTORY,
    label: ENERGYUSAGE_OPTION.HISTORY,
  },
];

export const UPGRADES_AND_VERSION_OPTION = {
  UPGRADES: "Upgrades",
  VERSION: "Version",
};

export const UPGRADES_AND_VERSION_OPTIONS_LIST = [
  {
    value: UPGRADES_AND_VERSION_OPTION.UPGRADES,
    label: UPGRADES_AND_VERSION_OPTION.UPGRADES,
  },
  {
    value: UPGRADES_AND_VERSION_OPTION.VERSION,
    label: UPGRADES_AND_VERSION_OPTION.VERSION,
  },
];

export const getSOCOptions = () => {
  const options = [];
  for (let i = 5; i <= 100; i += 5) {
    options.push({ value: i, label: `${i}%` });
  }
  return options;
};

export const getModemUsageOptions = () => {
  const options = [];
  for (let i = 0; i <= 100; i += 10) {
    options.push({ value: i, label: `${i}MB` });
  }
  for (let i = 200; i <= 2000; i += 100) {
    options.push({ value: i, label: `${i}MB` });
  }
  return options;
};

export const CONTROL_MODE = {
  default: "default",
  optimisation: "optimisation",
  vpp: "vpp",
};

export const CONTROL_MODE_OPTIONS = [
  { value: CONTROL_MODE.default, label: "Default (Self-Powered)" },
  {
    value: CONTROL_MODE.optimisation,
    label: "Optimisation (EmpowerIQ)",
  },
  { value: CONTROL_MODE.vpp, label: "VPP (External Control)" },
];

export const getControlMode = (mode) => {
  const item = CONTROL_MODE_OPTIONS.find((it) => it.value === mode);
  return item?.label ?? "Default (Self-Powered)";
};

export const ONBOARDING = "onboarding";
export const AMBER_STATUS = "amber_status";

export const ACTIVE = "active";
export const INACTIVE = "inactive";

export const ACTIVE_OPTIONS = [
  { label: "Active", value: ACTIVE },
  { label: "Inactive", value: INACTIVE },
];
